//=====================================================
//　医院システム情報
//=====================================================
import { AxiosResponse } from "axios";
import { useEffect, useState } from "react";
import { getApiData } from "./CallApi";
import { ConstMsg } from "../utils/ConstMsg";
import { IFUseSystemErr } from "./UseSystemErr";

//医院システム情報IF
export interface IFDataClinicSystemInfo {
    usability: {
        system: boolean,
        new: boolean,
        followUp: boolean,
        reFirst: boolean,
        patientEmail: boolean,
        smsNotification: boolean,
        appointment: {
            add: boolean,
            update: boolean,
            delete: boolean,
        }
    },
    display: {
        patientEmail: boolean,
        birthday: boolean,
        doctor: boolean,
        medicalType: boolean,
        medicalCareTime: boolean,
        phoneIcon: boolean,
    }
}

//医院システム情報初期値定数
export const InitDataClinicSystemInfo:IFDataClinicSystemInfo = {
    usability: {
        system: false,
        new: false,
        followUp: false,
        reFirst: false,
        patientEmail: false,
        smsNotification: false,
        appointment: {
            add: false,
            update: false,
            delete: false
        }
    },
    display: {
        patientEmail: false,
        birthday: false,
        doctor: false,
        medicalType: false,
        medicalCareTime: false,
        phoneIcon: false,
    }
}

//医院システム情報管理IF
export interface IFUseClinicSystemInfo {
    data: IFDataClinicSystemInfo,
}

//-----------------------------------------------------
//　医院システム情報管理
//-----------------------------------------------------
export function useClinicSystemInfo(clinicid:string, userr:IFUseSystemErr):IFUseClinicSystemInfo{

    const [data, setData] = useState<IFDataClinicSystemInfo>(InitDataClinicSystemInfo);

    //医院システム情報取得
    useEffect(
        function(){
            if (clinicid) {
                let apiUrl = `/c/${clinicid}/system`;

                getApiData(apiUrl, {},
                    function(res:AxiosResponse<any>){
                        if (res?.data) {
                            if(res.status===200){
                                let newData:IFDataClinicSystemInfo = Object.assign({}, InitDataClinicSystemInfo);
                                //APIから取得した値格納
                                newData.usability.system = res.data.usability.system ;
                                newData.usability.new = res.data.usability.new ;
                                newData.usability.followUp = res.data.usability.followUp ;
                                newData.usability.reFirst = res.data.usability.reFirst ;
                                newData.usability.patientEmail = res.data.usability.patientEmail ;
                                newData.usability.smsNotification = res.data.usability.smsNotification ;
                                newData.usability.appointment.add = res.data.usability.appointment.add ;
                                newData.usability.appointment.update = res.data.usability.appointment.update ;
                                newData.usability.appointment.delete = res.data.usability.appointment.delete ;
                                newData.display.patientEmail = res.data.display.patientEmail;
                                newData.display.birthday = res.data.display.birthday;
                                newData.display.doctor = res.data.display.doctor;
                                newData.display.medicalType = res.data.display.medicalType;
                                newData.display.medicalCareTime = res.data.display.medicalCareTime;
                                newData.display.phoneIcon = res.data.display.phoneIcon;
                                setData(newData);
                            } else {
                                userr.setErrmess(res.data.message);
                            }
                        } else {
                            userr.setErrmess(ConstMsg.EG9990001);
                        }
                    }
                );
            } else {
                let newData:IFDataClinicSystemInfo = Object.assign({}, InitDataClinicSystemInfo);
                setData(newData);
            }
        }, 
        // エラーメッセージを更新するため、userrは第2引数から除外する
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [clinicid]
    );

    return { data }

}